import { Box, Tab, Tabs } from '@mui/material'
import { useEffect, useState } from 'react'
import { Link, Outlet, Route, Routes, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { hasPermission } from 'store'
import RedirectToFirstPermitted from 'components/RedirectToPermittedTab'
import Protected from 'components/Protected'
import PersonProfile from './Profile'
import Contacts from '../Contact'
import Employments from '../Employment'
import Campuses from '../Campuses'
import Schedule from '../Schedule'
import 'utils/global.scss'

export const tabConfig = [
  { index: 0, label: 'Profile',    path: 'profile',    permission: 'people.profile' },
  { index: 1, label: 'Contacts',   path: 'contacts',   permission: 'people.contact' },
  { index: 2, label: 'Employment', path: 'employment', permission: 'people.employment' },
  { index: 3, label: 'Campus',     path: 'campus',     permission: 'people.campus' },
  { index: 4, label: 'Schedule',   path: 'schedule',   permission: 'people.schedule' },
]

export default function PersonDetailTabs() {
  const { t } = useTranslation()
  const theme = useSelector(state => state.session.appearance)
  const { personId, '*': tabName } = useParams()
  const basePath = `/people/staff/${personId}`

  const permittedTabs = tabConfig.filter(tab => !tab.permission || hasPermission(tab.permission))

  const getTabIndex = path => {
    const [segment] = path.split('/')
    const found = permittedTabs.find(tab => tab.path === segment)
    return found ? found.index : permittedTabs[0]?.index ?? 0
  }

  const [tabIndex, setTabIndex] = useState(getTabIndex(tabName))

  useEffect(() => {
    setTabIndex(getTabIndex(tabName))
  }, [tabName, permittedTabs.length])

  // No personId (e.g. drawer closing) → don't render/redirect, which would
  // otherwise navigate to `/people/staff/undefined/profile`.
  if (!personId) return null

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', displayPrint: 'none' }}>
        {personId && (
          <Tabs value={tabIndex} TabIndicatorProps={{ style: { background: 'primary', fontFamily: 'Roboto, sans-serif' } }}>
            {permittedTabs.map(tab => (
              <Tab
                key={tab.path}
                sx={{ color: tabIndex === tab.index && 'primary !important' }}
                className={tabIndex === tab.index ? 'tab-item-selected' : `tab-item-${theme}`}
                label={t(tab.label)}
                value={tab.index}
                component={Link}
                to={`${basePath}/${tab.path}`}
              />
            ))}
          </Tabs>
        )}
      </Box>
      <Routes>
        <Route path="" element={<Outlet />}>
          <Route index element={<RedirectToFirstPermitted basePath={basePath} items={tabConfig} />} />
          <Route path="profile/*" element={<Protected permission="people.profile"><PersonProfile /></Protected>} />
          <Route path="contacts/*" element={<Protected permission="people.contact"><Contacts /></Protected>} />
          <Route path="employment/*" element={<Protected permission="people.employment"><Employments /></Protected>} />
          <Route path="campus/*" element={<Protected permission="people.campus"><Campuses /></Protected>} />
          <Route path="schedule/*" element={<Protected permission="people.schedule"><Schedule /></Protected>} />
        </Route>
      </Routes>
    </Box>
  )
}
